import type { BulkImportContact } from 'hooks/api'
import type { ParsedContactPreview } from 'utils/csv'

export interface SharedField {
  key: string
  value: string
}

export interface SharedAssociation {
  kind: 'schoolLocations' | 'vendorLocations' | 'organizations'
  externalId: string
  role: string
}

export const KNOWN_CONTACT_FIELDS = new Set([
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'organizationName',
  'notes',
  'ordoUserId',
  'timezone',
])

export function previewToBulkContact(
  preview: ParsedContactPreview,
  sharedFields: SharedField[],
  sharedAssociations: SharedAssociation[],
): BulkImportContact {
  const contact: BulkImportContact = {}

  for (const field of KNOWN_CONTACT_FIELDS) {
    const val = (preview as Record<string, string | undefined>)[field]
    if (val) {
      ;(contact as Record<string, string>)[field] = val
    }
  }

  // Build extraData from preview extras
  const extraData: Record<string, unknown> = {}
  if (preview.extraData) {
    for (const [key, val] of Object.entries(preview.extraData)) {
      if (val) {
        extraData[key] = val
      }
    }
  }

  // Apply shared fields
  for (const { key, value } of sharedFields) {
    if (!key || !value) {
      continue
    }
    if (KNOWN_CONTACT_FIELDS.has(key)) {
      // Only fill if the contact doesn't already have a value
      if (!(contact as Record<string, unknown>)[key]) {
        ;(contact as Record<string, string>)[key] = value
      }
    } else {
      extraData[key] = value
    }
  }

  if (Object.keys(extraData).length > 0) {
    contact.extraData = extraData
  }

  // Apply shared associations
  for (const assoc of sharedAssociations) {
    if (!assoc.externalId || !assoc.role) {
      continue
    }
    const entry = { externalId: assoc.externalId, role: assoc.role }
    if (!contact[assoc.kind]) {
      contact[assoc.kind] = []
    }
    contact[assoc.kind]!.push(entry)
  }

  return contact
}
